import { useSearchSuggestQuery as e } from "./useSearchSuggestQuery.mjs";
import { useAuth as t } from "@maat/store-auth";
import { SearchSuggestRail as n } from "@maat/api-main/types";
import { useMemo as r } from "react";
//#region src/properties/useSearchSuggestRails.ts
var i = [n.Places, n.AskMaat], a = (e, t) => {
	if (t || e[0] !== n.AskMaat) return e;
	let r = e.slice(1), i = r.indexOf(n.Properties);
	return i === -1 ? e : [
		...r.slice(0, i + 1),
		n.AskMaat,
		...r.slice(i + 1)
	];
}, o = (o) => {
	let { isAuthenticated: s } = t(), { data: c } = e(o), l = c?.query === o, u = r(() => a(c?.query === o ? c.rails : i, s), [
		c,
		o,
		s
	]);
	return {
		suggest: l ? c : void 0,
		rails: u,
		verdictKnown: l,
		placesLeads: u[0] === n.Places
	};
};
//#endregion
export { i as DEFAULT_SEARCH_RAILS, a as orderRailsForViewer, o as useSearchSuggestRails };
